import React from "react";

import { AppMenuItem } from "../AppMenuItem/AppMenuItem";
import { useNavigationItems } from "../useNavigationItems";

import "./index.scss";

export interface AppMenuProps {}

export const AppMenu: React.FC<AppMenuProps> = () => {
  const navigationItems = useNavigationItems();

  return (
    <ul className="app-menu">
      {navigationItems.map((item, idx) => (
        <AppMenuItem key={idx} {...item} />
      ))}
    </ul>
  );
};
